
@if (!wideCard) {
  <mat-card class="mt-settle-loan-card">
    @for (attr of attributes; track attr) {
      <mat-card-content matRipple (click)="onCardClick()">
        <!-- check if headers exist -->
        @if (attr.headers && attr.headers.length) {
          <div class="mt-settle-loan-header" fxLayout="row" fxLayoutAlign="space-between start">
            @for (header of attr.headers; track header) {
              @if (header.type === 'title') {
                <div class="header-left-section">
                  <mt-h3 [ngClass]="header.class">{{
                    value | dataFormatter: value:header.prop | formatter: header.pipe
                  }}</mt-h3>
                </div>
              }
              @if (header.type === 'img') {
                <div class="header-right-section">
                  <img [src]="value | dataFormatter: value:header.prop" (error)="errorHandler($event)" height="54" width="54" alt="icon" />
                </div>
              }
            }
            @if (editButton) {
              <div>
                <mt-btn class="nobg primary" (onAction)="editData(value)">
                  <span class="ic_pencil small"></span>
                </mt-btn>
              </div>
            }
          </div>
          <!-- <span class="sp"></span> -->
        }
        <!-- check if body exist -->
        @if (attr.body && attr.body.length) {
          @for (tile of attr.body; track tile) {
          <!-- </mat-grid-list> -->
          @if (tile.name === 'SubTitle') {
            <div class="mt-settle-loan-body">
              <div [class]="tile.class" >
                <div class="mt-offer-body-text">
                  <div class="card-col-sec">
                    <p style="min-height: 30px;">
                      {{ value | dataFormatter: value:tile.prop | formatter: tile.pipe }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          }
        }
      }
      <div class="settel-date-wrap">
        @if (attr.body && attr.body.length) {
          @for (tile of attr.body; track tile) {
            <!-- <mat-grid-list [cols]="getColumns(attr)" [rowHeight]="52"> -->
            @if (tile.name !== 'SubTitle') {
              <div class="mt-settle-loan-body">
                <div [class]="tile.class" >
                  <div class="mt-offer-body-text">
                    <div class="card-col-sec">
                      @if (tile.name) {
                        <label>{{ tile.name }}</label>
                      }
                      <p>
                        {{ value | dataFormatter: value:tile.prop | formatter: tile.pipe }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            }
          }
        }
      </div>
      <!-- <div style="width: 100%;display: flex;justify-content: space-between;">
      <div>
        <span style="color: #a099a6; font-weight: 600;display:block;"> Created  </span>
        <span>23 Apr 2021</span>
      </div>
      <div>
        <span style="color: #a099a6; font-weight: 600;display:block;"> Last Updated  </span>
        <span>23 Apr 2021</span>
      </div>
      <div>
        <span style="color: #a099a6; font-weight: 600;display:block;"> Expired  </span>
        <span>23 Apr 2021</span>
      </div>
    </div> -->
  </mat-card-content>
  <!-- check if footers are exist -->
  @if (attr.footers && attr.footers.length) {
    <mat-card-actions style="padding: 12px;" class="mt-settle-loan-footer">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        @for (footer of attr.footers; track footer) {
          @if (footer.dir === 'left') {
            <div fxLayout="column">
              @if (footer.name) {
                <p [ngClass]="getClass(value).fontClass">
                  {{ value | dataFormatter: value:footer.name | formatter: footer.pipe }}
                  <!-- {{ getClass(value).title }} -->
                </p>
              }
              @if (footer.name1) {
                <p>
                  {{ this.value.fieldJSON1.waiverType === 2 ? "Max Markup": "Max Discount" }}:
                  {{
                  value
                  | dataFormatter: value:footer.prop
                  | formatter: (footer.switchPipe ? switchPipeValue(value) : footer.pipe)
                  }}
                </p>
              }
            </div>
          }
          @if (footer.dir === 'right') {
            @if (applyButtonFlag && !acceptButtonFlag) {
              <mt-btn
                class="rounded"
                (onAction)="applyOffer(value)"
                [class]="'rounded ' + (selected ? ' ' : ' outline ')"
                [ngClass]="{'isAppliedOffer' : selected }"
                >
                {{ selected ? 'Applied' : footer.name }}
              </mt-btn>
            }
            @if (acceptButtonFlag && !applyButtonFlag) {
              <mt-btn
                [disabled]="!acceptOfferButtonFlag"
                class="rounded"
                (onAction)="acceptOffer(value)"
                [class]="'rounded ' + (acceptOfferButtonFlag ? ' ' : ' outline ')"
                >
                {{ acceptOfferButtonFlag ? 'Accept' : 'Accepted' }}
              </mt-btn>
            }
            @if (!acceptButtonFlag && !applyButtonFlag) {
              <mt-btn class="icon" [matMenuTriggerFor]="openOptions">
                <mat-icon>more_vert</mat-icon>
              </mt-btn>
            }
          }
        }
      </div>
    </mat-card-actions>
  }
}
</mat-card>
}

<mat-menu #openOptions="matMenu" overlapTrigger="false">
  <a mat-menu-item (click)="onEditOfferClick(value.id)">Edit</a>
  <a mat-menu-item (click)="onDeactivateClick(value.id)">Deactivate</a>
</mat-menu>

@if (showModal) {
  <mt-modal
    [buttons]="buttons"
    (onAction)="onModalAction($event)"
    [title]="'Are you sure want to deactivate the offer?'"
    >
    @if (value && value.title) {
      <mt-h4>Selected offer: {{ value.title }}</mt-h4>
    }
  </mt-modal>
}

<!-- offer-card-full-size -->
@if (wideCard) {
  <mat-card class="mt-20 mt-settle-loan-card-wide mt-settle-loan-card">
    @for (attr of attributes; track attr) {
      <mat-card-content matRipple (click)="onCardClick()">
        <!-- check if headers exist -->
        <div class="row row-equal">
          <div class="col-md-4 no-gutter">
            @if (attr.headers && attr.headers.length) {
              <div class="mt-settle-loan-header-wide mt-settle-loan-header">
                @for (header of attr.headers; track header) {
                  @if (header.type === 'title') {
                    <div class="header-left-section">
                      <mt-h3 [ngClass]="header.class">{{
                        value | dataFormatter: value:header.prop | formatter: header.pipe
                      }}</mt-h3>
                    </div>
                  }
                  @if (header.type === 'subTitle') {
                    <div class="subheader-left-section mt-10 col-md-9 no-gutter">
                      <label [ngClass]="header.class">{{
                        value | dataFormatter: value:header.prop | formatter: header.pipe
                      }} </label>
                    </div>
                  }
                }
                @if (editButton) {
                  <div>
                    <mt-btn class="nobg primary" (onAction)="editData(value)">
                      <span class="ic_pencil small"></span>
                    </mt-btn>
                  </div>
                }
              </div>
              <!-- <span class="sp"></span> -->
            }
            <!-- <div class="row">
            <label *ngIf="tile.name">{{ tile.name }} : {{ value | dataFormatter: value:tile.prop | formatter: tile.pipe }} </label>
          </div> -->
          <!-- check if footers are exist -->
          <div class="mt-settle-loan-footer-wide mb-10">
            @if (attr.footers && attr.footers.length) {
              <div>
                <div fxLayout="row" fxLayoutAlign="space-between center">
                  @for (footer of attr.footers; track footer) {
                    @if (footer.dir === 'left') {
                      <div fxLayout="column">
                        @if (footer.name) {
                          <p [ngClass]="getClass(value).fontClass">
                            {{ value | dataFormatter: value:footer.name | formatter: (footer.switchPipe ? switchPipeValue(value) : footer.pipe)}}
                          </p>
                        }
                        <!-- <p *ngIf="footer.name1">
                        {{ footer.name1 }}:
                        {{
                        value
                        | dataFormatter: value:footer.prop
                        | formatter: (footer.switchPipe ? switchPipeValue(value) : footer.pipe)
                        }}
                      </p> -->
                    </div>
                  }
                  @if (footer.dir === 'right') {
                    @if (footer.type === 'img') {
                      <div class="header-right-section">
                        <img [src]="value | dataFormatter: value:footer.prop" (error)="errorHandler($event)" height="70" width="70" alt="icon" />
                      </div>
                    }
                    <!-- <ng-container *ngIf="applyButtonFlag">
                    <mt-btn
                      class="rounded"
                      (onAction)="applyOffer(value)"
                      [class]="'rounded ' + (selected ? ' ' : ' outline ')"
                      >
                      {{ selected ? 'Applied' : footer.name }}
                    </mt-btn>
                  </ng-container> -->
                  @if (!applyButtonFlag) {
                    <mt-btn class="icon" [matMenuTriggerFor]="openOptions">
                      <mat-icon>more_vert</mat-icon>
                    </mt-btn>
                  }
                }
              }
            </div>
          </div>
        }
      </div>
    </div>
    <!-- check if body exist -->
    <div class="col-md-8 no-gutter">
      @if (attr.body && attr.body.length) {
        <div class="row">
          <!-- <mat-grid-list [cols]="getColumns(attr)" [rowHeight]="52"> -->
          @for (tile of attr.body; track tile) {
            <!-- <mat-grid-tile class="mt-offer-body-text"> -->
            <div [class]="tile.class">
              @if (tile.name) {
                <label>{{ tile.name }} : {{ value | dataFormatter: value:tile.prop | formatter: (tile.switchPipe ? switchPipeValue(value) : tile.pipe)}} </label>
              }
              <!-- <p [ngClass]="tile.class">
            </p> -->
          </div>
        <!-- </mat-grid-tile> -->
      }
    <!-- </mat-grid-list> -->
  </div>
}
</div>
</div>
</mat-card-content>
}
</mat-card>
}
